import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SetStateAction, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { OutcomesContext } from "../../pages/outcomes/OutcomesContext";
import { ChoiceOption, Client, OutcomeEvaluation, OutcomeEvaluationAnswer, OutcomesEvaluation, OutcomesGroup, OutcomesQuestion } from "../../utils/Definitions";
import pic1562 from '../../images/1562.png'; 
import pic222 from '../../images/222.png'; 
import pic255 from '../../images/255.png'; 
import pic889 from '../../images/889.png'; 
import pic94 from '../../images/94.png'; 
import ProtectedComponent from "../../utils/ProtectedComponent";
import { ProfilePicture } from "../ProfilePicture";
import { GlobalContext } from "../../utils/GlobalContext";
import { ModalNotification } from "../ModalNotification";
import { OutcomesQuestionTypeChoice } from "./OutcomesQuestionTypeChoice";
import { OutcomesQuestionTypeMultiChoice } from "./OutcomesQuestionTypeMultiChoice";
import { OutcomesQuestionTypeText } from "./OutcomesQuestionTypeText";
import { OutcomesQuestionTypeNumber } from "./OutcomesQuestionTypeNumber";
import { Profile } from "../../pages/Profile";
import { OutcomesQuestionTypeVineland } from "./OutcomesQuestionTypeVineland";


interface Props {
    OutcomeGroup: OutcomesGroup;
    OutcomeSelectedGroup: number | null;
    SetOutcomeSelectedGroup: React.Dispatch<React.SetStateAction<number | null>>;

    GetMultiChoiceSelectedOptions: any;
    OutcomeEvaluation: OutcomeEvaluation | null;
    setOutcomeEvaluationObject: React.Dispatch<React.SetStateAction<OutcomeEvaluation | null>>;
    onChange: any;
    ChildChoiceOnChange: any;
    ChildMultiOnChange: any;
    ChildOnChange: any;
    GetSelectedOption: any;
    NullQuestion: any;
    GetText: any;
    SetValidations: any;
    GetValidation: any;
    GetNullValue: any;
}

export const OutcomesQuestionGroup: React.FC<Props> = (props) => {
    function GetGroupStatus(): string {
        let tempComplete = false;
        const tempVinelandQuestions = props.OutcomeGroup.outcomesQuestions.filter(
            (x) => x.question.questionType == "vineland"
        );

        props.OutcomeGroup.outcomesQuestions.forEach((question) => {
            const answerFound = props.OutcomeEvaluation?.answers.find(
                (answer) => answer.questionID == question.question.questionId
            );

            if (!answerFound || answerFound.value == null || answerFound.value == "") {
                const nullableFound = props.OutcomeEvaluation?.nullables.find(
                    (x) => x.questionID == question.question.questionId
                );

                if (nullableFound?.value != "True") {
                    tempComplete = true;
                }
            } else if (
                tempVinelandQuestions &&
                tempVinelandQuestions.find((x) => x.question.questionId == answerFound?.questionID)
            ) {
                const pattern: RegExp = /^(>|<)?(\d+)(?::(\d+))?\+?$/;
                const isMatch: boolean = pattern.test(answerFound.value);
                if (!isMatch) {
                    tempComplete = true;
                }
            }
        });

        return tempComplete ? "Incomplete" : "Complete";
    }

    function OnClickSelectGroup() {
        props.SetOutcomeSelectedGroup(props.OutcomeGroup.groupId);
    }

    function EvaluationNullVineland(isNull: boolean) {
        if (props.OutcomeEvaluation) {
            props.setOutcomeEvaluationObject((prev: OutcomeEvaluation | null) => {
                if (!prev) return null;

                return {
                    ...prev,
                    evaluation: {
                        ...prev.evaluation,
                        vinelandIsNull: isNull,
                    },
                };
            });
        }
    }

    return (
        <div key={props.OutcomeGroup.groupId} className="mt-4">
            {/* Expanded group (always mounted, hidden if not active) */}
            <div
                className={
                    props.OutcomeSelectedGroup === props.OutcomeGroup.groupId ? "block" : "hidden"
                }
            >
                {props.OutcomeGroup.outcomesQuestions?.map((question) => {
                    switch (question.question.questionType) {
                        case "choice":
                            return (
                                <OutcomesQuestionTypeChoice
                                    key={question.question.questionId}
                                    onChange={props.onChange}
                                    OutcomeEvaluation={props.OutcomeEvaluation}
                                    OutcomesQuestion={question}
                                    setOutcomeEvaluationObject={props.setOutcomeEvaluationObject}
                                    ChildChoiceOnChange={props.ChildChoiceOnChange}
                                    GetSelectedOption={props.GetSelectedOption}
                                    NullQuestion={props.NullQuestion}
                                    GetNullValue={props.GetNullValue}
                                />
                            );

                        case "multichoice":
                            return (
                                <OutcomesQuestionTypeMultiChoice
                                    key={question.question.questionId}
                                    onChange={props.onChange}
                                    OutcomeEvaluation={props.OutcomeEvaluation}
                                    OutcomesQuestion={question}
                                    setOutcomeEvaluationObject={props.setOutcomeEvaluationObject}
                                    GetMultiChoiceSelectedOptions={props.GetMultiChoiceSelectedOptions}
                                    ChildOnChange={props.ChildMultiOnChange}
                                    NullQuestion={props.NullQuestion}
                                    GetNullValue={props.GetNullValue}
                                />
                            );

                        case "text":
                            return (
                                <OutcomesQuestionTypeText
                                    key={question.question.questionId}
                                    onChange={props.onChange}
                                    OutcomeEvaluation={props.OutcomeEvaluation}
                                    OutcomesQuestion={question}
                                    setOutcomeEvaluationObject={props.setOutcomeEvaluationObject}
                                    ChildOnChange={props.ChildOnChange}
                                    GetText={props.GetText}
                                    NullQuestion={props.NullQuestion}
                                    GetNullValue={props.GetNullValue}
                                />
                            );

                        case "vineland":
                            return (
                                <OutcomesQuestionTypeVineland
                                    key={question.question.questionId}
                                    onChange={props.onChange}
                                    OutcomeEvaluation={props.OutcomeEvaluation}
                                    OutcomesQuestion={question}
                                    setOutcomeEvaluationObject={props.setOutcomeEvaluationObject}
                                    ChildOnChange={props.ChildOnChange}
                                    GetText={props.GetText}
                                    NullQuestion={props.NullQuestion}
                                    SetValidations={props.SetValidations}
                                    GetValidation={props.GetValidation}
                                    GetNullValue={props.GetNullValue}
                                />
                            );

                        case "number":
                            return (
                                <OutcomesQuestionTypeNumber
                                    key={question.question.questionId}
                                    onChange={props.onChange}
                                    OutcomeEvaluation={props.OutcomeEvaluation}
                                    OutcomesQuestion={question}
                                    setOutcomeEvaluationObject={props.setOutcomeEvaluationObject}
                                    ChildOnChange={props.ChildOnChange}
                                    GetText={props.GetText}
                                    NullQuestion={props.NullQuestion}
                                    GetNullValue={props.GetNullValue}
                                />
                            );

                        default:
                            return <div key={question.question.questionId}></div>;
                    }
                })}
            </div>

            {/* Collapsed view (Vineland gets card, others get back arrow) */}
            <div
                className={
                    props.OutcomeSelectedGroup === props.OutcomeGroup.groupId ? "hidden" : "block"
                }
            >
                {props.OutcomeGroup.groupId === 1 ? (
                    <div className="w-full xl:w-[38rem] h-fit bg-gray-50 border drop-shadow rounded mt-4 p-2">
                        <span className="text-xl font-bold">{props.OutcomeGroup.groupText}</span>

                        <div className="w-full h-fit m-auto flex">
                            <div className="h-fit w-fit ml-auto my-auto mr-4">
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="sr-only peer"
                                        checked={props.OutcomeEvaluation?.evaluation.vinelandIsNull}
                                        onChange={(event) =>
                                            EvaluationNullVineland(event.target.checked)
                                        }
                                    />
                                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                    <span className="ml-3 text-sm font-medium">N/A</span>
                                </label>
                            </div>

                            <span>Status:</span>
                            <span
                                className={
                                    "grow ml-1 font-bold " +
                                    (props.OutcomeEvaluation?.evaluation.vinelandIsNull
                                        ? "text-lacgreen"
                                        : GetGroupStatus() === "Complete"
                                            ? "text-lacgreen"
                                            : "text-rose")
                                }
                            >
                                {props.OutcomeEvaluation?.evaluation.vinelandIsNull
                                    ? "N/A"
                                    : GetGroupStatus()}
                            </span>

                            <button
                                onClick={() => OnClickSelectGroup()}
                                disabled={props.OutcomeEvaluation?.evaluation.vinelandIsNull}
                                className={
                                    "bg-lacblue m-auto w-[6rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600 " +
                                    (props.OutcomeEvaluation?.evaluation.vinelandIsNull
                                        ? "bg-lacblue-600"
                                        : "")
                                }
                            >
                                <span className="drop-shadow">Edit</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="w-full xl:w-[38rem] h-fit mt-4 p-2">
                        <div
                            onClick={() => OnClickSelectGroup()}
                            className="flex items-center justify-center w-40 cursor-pointer col-span-2"
                        >
                            <div>
                                <FontAwesomeIcon
                                    className="w-8 h-8 mr-auto align-middle"
                                    icon={solid("arrow-left")}
                                />
                            </div>
                            <span className="text-xl w-auto ml-3">Back</span>
                            <div className="flex-1"></div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};


